import React from 'react';
import { Flex, Text } from 'rebass/styled-components';
import { useSelector } from 'react-redux';

import { userSelector } from '../../../redux/selectors';
import EmailForm from './EmailForm';
import PasswordForm from './PasswordForm';

const LoginInfo = () => {
  const user = useSelector(userSelector);
  const mapOauthProviders = {
    google_oauth2: 'Google',
    linkedin: 'LinkedIn',
  };

  return (
    <Flex sx={{ flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
      <Text fontSize="14px" fontWeight="medium" color="text.dark">
        Email & password
      </Text>
      <EmailForm />
      {user.hasPassword ? (
        <PasswordForm />
      ) : (
        <Text fontSize="14px">{`You signed up through ${mapOauthProviders?.[user.oauthProviders[0]?.provider]}.`}</Text>
      )}
    </Flex>
  );
};

export default LoginInfo;
